import { defineStore } from 'pinia'
import type { Order } from '@/types/order'
import type { Quote } from '@/types/shipment'

interface QuoteState {
  selectedOrder: Order | null
  selectedQuote: Quote | null
  quotes: Quote[]
  quoteId: number
}

export const useQuoteStore = defineStore('quote', {
  state: (): QuoteState => ({
    selectedOrder: JSON.parse(localStorage.getItem('selectedOrder') || 'null'),
    selectedQuote: JSON.parse(localStorage.getItem('selectedQuote') || 'null'),
    quotes: JSON.parse(localStorage.getItem('quotes') || '[]'),
    quoteId: localStorage.getItem('quoteId')
      ? Number(localStorage.getItem('quoteId'))
      : 0,
  }),

  actions: {
    setSelectedOrder(order: Order) {
      this.selectedOrder = order
      localStorage.setItem('selectedOrder', JSON.stringify(order))
    },

    clearSelectedOrder() {
      this.selectedOrder = null
      localStorage.removeItem('selectedOrder')
    },

    setQuotes(quotes: Quote[]) {
      this.quotes = quotes
      localStorage.setItem('quotes', JSON.stringify(quotes))
    },
    setQuoteId(quoteId: number) {
      this.quoteId = quoteId
      localStorage.setItem('quoteId', JSON.stringify(quoteId))
    },
    selectQuote(quote: Quote) {
      this.selectedQuote = quote
      localStorage.setItem('selectedQuote', JSON.stringify(quote))
    },

    clearQuotes() {
      this.quotes = []
      this.selectedQuote = null
      localStorage.removeItem('quotes')
      localStorage.removeItem('selectedQuote')
      localStorage.removeItem('quoteId')
    },
  },
})
